import localforage from 'localforage';

// Small reusable persistence helper for per-page UI preferences (panel collapse
// state today; per-panel filter/sort/page-size later). Backed by localforage so a
// choice survives a refresh AND a browser close, matching how the sidebar collapse
// preference is stored in contexts/Interface.js. Each pref is its own key (no
// read-modify-write of a shared blob) so independent panels never race each other.

const PREFIX = 'est.ui.';

export function getUIPref(key) {
    if(!key) {
        return Promise.resolve(undefined);
    }
    return localforage.getItem(PREFIX + key)
        .then(value => (value === null ? undefined : value))
        .catch(e => {
            console.log('Error reading UI pref ', key, e);
            return undefined;
        });
}

export function setUIPref(key, value) {
    if(!key) {
        return Promise.resolve();
    }
    return localforage.setItem(PREFIX + key, value)
        .catch(e => {
            console.log('Error saving UI pref ', key, e);
        });
}
